import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HCPCSAndNDCCodes, HCPCSCodes } from 'src/app/models/HCPCSCodes';
import { configuration } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MasterService {

  constructor(private http: HttpClient) { }

  GetAllHCPCSCodes(): Observable<HCPCSCodes[]> {
    return this.http.get<HCPCSCodes[]>(`${configuration.apiUrl + 'Master/HCPCSCodes'}?userId=${sessionStorage.getItem("userId")}`);
  }

  GetAllHCPCSAndNDCCodes(): Observable<HCPCSAndNDCCodes[]> {
    return this.http.get<HCPCSAndNDCCodes[]>(`${configuration.apiUrl + 'Master/HCPCSandNDCCodes'}?userId=${sessionStorage.getItem("userId")}`);
  }

  InsertOrUpdateHcpcsAndndcInfo(ndcAndhcpcsInfo: HCPCSAndNDCCodes): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(ndcAndhcpcsInfo)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Master/HCPCSandNDCCodes'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
}
